import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { partial, uniqueId } from 'lodash';
/**
 * Create a panel of styled selectable options rendering stylized checkboxes and labels
 */

var SegmentedSelection =
/*#__PURE__*/
function (_Component) {
  _inherits(SegmentedSelection, _Component);

  function SegmentedSelection() {
    _classCallCheck(this, SegmentedSelection);

    return _possibleConstructorReturn(this, _getPrototypeOf(SegmentedSelection).apply(this, arguments));
  }

  _createClass(SegmentedSelection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          options = _this$props.options,
          selected = _this$props.selected,
          onSelect = _this$props.onSelect,
          name = _this$props.name,
          legend = _this$props.legend;
      return createElement("fieldset", {
        className: "woocommerce-segmented-selection"
      }, createElement("legend", {
        className: "screen-reader-text"
      }, legend), createElement("div", {
        className: classnames(className, 'woocommerce-segmented-selection__container')
      }, options.map(function (_ref) {
        var value = _ref.value,
            label = _ref.label;

        if (!value || !label) {
          return null;
        }

        var id = uniqueId("".concat(value, "_"));
        return createElement("div", {
          className: "woocommerce-segmented-selection__item",
          key: value
        }, createElement("input", {
          className: "woocommerce-segmented-selection__input",
          type: "radio",
          name: name,
          id: id,
          checked: selected === value,
          onChange: partial(onSelect, _defineProperty({}, name, value))
        }), createElement("label", {
          htmlFor: id
        }, createElement("span", {
          className: "woocommerce-segmented-selection__label"
        }, label)));
      })));
    }
  }]);

  return SegmentedSelection;
}(Component);

SegmentedSelection.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * An Array of options to render. The array needs to be composed of objects with properties `label` and `value`.
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,

  /**
   * Value of selected item.
   */
  selected: PropTypes.string,

  /**
   * Callback to be executed after selection
   */
  onSelect: PropTypes.func.isRequired,

  /**
   * This will be the key in the key and value arguments supplied to `onSelect`.
   */
  name: PropTypes.string.isRequired,

  /**
   * Create a legend visible to screen readers.
   */
  legend: PropTypes.string.isRequired
};
export default SegmentedSelection;
//# sourceMappingURL=index.js.map